import { render } from "./CourseScreen.vue?vue&type=template&id=8a9b89d2&scoped=true"
import script from "./CourseScreen.vue?vue&type=script&lang=js"
export * from "./CourseScreen.vue?vue&type=script&lang=js"

import "./CourseScreen.vue?vue&type=style&index=0&id=8a9b89d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9b89d2"]])

export default __exports__